/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/first_aid_medium'
export default icon
